import Vue from 'vue';

export const dataPinningEventBus = new Vue();
